import { render, staticRenderFns } from "./ViewPoint.vue?vue&type=template&id=2d433b14&scoped=true&"
import script from "./ViewPoint.vue?vue&type=script&lang=js&"
export * from "./ViewPoint.vue?vue&type=script&lang=js&"
import style0 from "./ViewPoint.vue?vue&type=style&index=0&id=2d433b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d433b14",
  null
  
)

export default component.exports